import { getState } from '../analytics-state';
import { ONLINE_STORE } from '../constants';

const { take, race, delay } = LIFE_CYCLE_EVENT_BUS.effects;

/**
 * Will return when the next data source for a give type and optional domain set are available
 * @param dataType {String} - product or search
 * @param opts {Object} - {domains: ['identifiers]}
 * @returns {Generator}
 */
export function* nextDataSource(dataType, opts = {}) {
  let running = true;
  let response = {};
  const runners = {
    complete: take('data-sources.data'), // 'data-sources.data',
    error: take('data-sources.error')// 'data-sources.error'
  };

  if (opts.timeout) {
    runners.timeout = delay(opts.timeout);
  }
  while (running) {
    response = yield race(runners);
    if (response.complete?.output?.type === dataType) {
      const storeId = response.complete?.output?.variables?.storeId || ONLINE_STORE;
      if (opts.domains) {
        if (dataType === 'product') {
          const state = getState();
          const itemId = response.complete.output.data?.product?.itemId;
          const product = response.complete.output.data?.product || {};
          let keys = Object.keys(product);
          if (itemId && state.dataSources?.product?.[itemId]?.product) {
            keys = keys.concat(Object.keys(state.dataSources?.product?.[itemId]?.product) || {});
          }
          keys = keys.filter((key) => key !== '__typename');
          const hasDomains = opts.hardDependencyDomain
            ? opts.domains.every((domain) => !product[domain])
            : opts.domains.every((domain) => keys.indexOf(domain) > -1);
          if (hasDomains && storeId !== ONLINE_STORE && product?.__typename === 'BaseProduct') {
            running = false;
          }
        } else if (dataType === 'search') {
          // @todo need to do search domains
          const searchModel = response.complete.output.data?.searchModel || {};
          let keys = Object.keys(searchModel);
          // does not make sense for search to concat keys from data state, probably not product either
          // const state = getState();
          // keys = keys.concat(Object.keys(state.dataSources?.search?.searchModel) || {});
          keys = keys.filter((key) => key !== '__typename');
          const hasDomains = (opts.domains || []).every((domain) => keys.indexOf(domain) > -1);
          if (hasDomains && storeId !== '8119') {
            running = false;
          }
        }
      } else {
        running = false;
      }

    } else if (response.error?.output?.type === dataType) {
      running = false;
    } else if (response.timeout) {
      running = false;
    }

  }
  return response.complete || response.error || { timeout: true };
}
